import { IconKvBucks } from '@/presentation/components/icons';
import React from 'react';
import Styles from './header-styles.scss';
import ButtonKVBase from '@/presentation/components/button-kv/button-kv';
import { formatStringAccountBalance } from '@/presentation/utils/money-utils';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
const BalanceHeader = () => {
    const { checkingAccount } = useStudentAccounts(true);
    return (React.createElement("div", { className: Styles.wrap },
        React.createElement("div", { className: Styles.clientFreeTrial },
            React.createElement("div", null,
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "#89C900", leftIcon: React.createElement(IconKvBucks, null) },
                    formatStringAccountBalance(checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.balance),
                    " KV")))));
};
export default BalanceHeader;
